// src/modules/components/Footer/index.js
import React from 'react';
import { FaLinkedin, /* FaInstagram, */ FaYoutube, FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

// Contexto de tradução GLOBAL
import { useTranslation } from '../../../contexts/LanguageContext';

import logoVega from '../../../assets/logovega.svg';

import {
  FooterContainer,
  FooterContent,
  FooterMain,
  FooterBrand,
  Logo,
  LogoExternal,
  BrandDescription,
  NvidiaInceptionBadge,
  FooterLinks,
  FooterLinkGroup,
  GroupTitle,
  FooterLink,
  ContactItem,
  SocialLinks,
  SocialLink,
  FooterBottom,
  Copyright,
  LegalLinks,
  LegalLink,
  // REMOVIDO: BackToTop - já existe ScrollToTopButton global
} from './styles';

// Detecta se está no subdomínio blog (apenas blog deve ir para vegarobotics.com.br)
const isBlogSubdomain = () => {
  const hostname = window.location.hostname;
  return hostname === 'blog.vegarobotics.com.br';
};

// URL do domínio principal
const mainDomainUrl = 'https://www.vegarobotics.com.br';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const emailLink = "mailto:contato@vegarobotics.com.br?subject=Contato - Vega Robotics";
  const whatsappLink = "https://wa.me/5511944271000?text=Olá! Gostaria de saber mais sobre as soluções da Vega Robotics.";
  const linkedinLink = "https://www.linkedin.com/company/vegarobotics";
  // const instagramLink = "https://www.instagram.com/vega.robotics/"; // TEMPORARIAMENTE OCULTO
  const youtubeLink = "https://www.youtube.com/@vega_robotics";
  const mapsLink = "https://maps.google.com/?q=Av.+Alan+Turing,+345+-+Sala+11+-+Cidade+Universitária,+Campinas+-+SP";

  return (
    <FooterContainer>
      <FooterContent>
        <FooterMain>
          <FooterBrand>
            {isBlogSubdomain() ? (
              <LogoExternal href={mainDomainUrl}>
                <img src={logoVega} alt={t('general.company')} />
              </LogoExternal>
            ) : (
              <Logo to="/">
                <img src={logoVega} alt={t('general.company')} />
              </Logo>
            )}
            <BrandDescription>
              {t('footer.description')}
            </BrandDescription>
            <NvidiaInceptionBadge 
              href="https://www.nvidia.com/en-us/startups/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              NVIDIA Inception
            </NvidiaInceptionBadge>
          </FooterBrand>

          <FooterLinks>
            <FooterLinkGroup>
              <GroupTitle>{t('footer.solutions')}</GroupTitle>
              <FooterLink as="a" href="https://cadpro.vegarobotics.com.br">
                {t('solutions.engenhariaAplicada.name')}
              </FooterLink>
              <FooterLink to="/solucoes/automacao-industrial">
                {t('solutions.automacaoIndustrial.name')}
              </FooterLink>
              <FooterLink to="/solucoes/qualidade-inteligente">
                {t('solutions.qualidadeInteligente.name')}
              </FooterLink>
              <FooterLink to="/solucoes/agentes-industriais">
                {t('solutions.agentesIndustriais.name')}
              </FooterLink>
            </FooterLinkGroup>

            <FooterLinkGroup>
              <GroupTitle>{t('footer.links.title')}</GroupTitle>
              <FooterLink as="a" href="https://blog.vegarobotics.com.br">
                {t('nav.blog')}
              </FooterLink>
              <FooterLink to="/carreiras">
                {t('nav.careers')}
              </FooterLink>
              <FooterLink to="/privacidade">
                {t('footer.privacy')}
              </FooterLink>
              <FooterLink to="/termos">
                {t('footer.terms')}
              </FooterLink>
            </FooterLinkGroup>

            <FooterLinkGroup>
              <GroupTitle>{t('footer.contact')}</GroupTitle>
              <ContactItem href={emailLink}>
                <FaEnvelope />
                <span>contato@vegarobotics.com.br</span>
              </ContactItem>
              <ContactItem href={whatsappLink} target="_blank" rel="noopener noreferrer">
                <FaWhatsapp />
                <span>WhatsApp</span>
              </ContactItem>
              <ContactItem href={mapsLink} target="_blank" rel="noopener noreferrer">
                <FaMapMarkerAlt />
                <span>Av. Alan Turing, 345 - Sala 11<br />Campinas - SP, 13083-898</span>
              </ContactItem>
            </FooterLinkGroup>
          </FooterLinks>

          <SocialLinks>
            <SocialLink href={linkedinLink} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </SocialLink>
            {/* TEMPORARIAMENTE OCULTO - Instagram
            <SocialLink href={instagramLink} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </SocialLink>
            */}
            <SocialLink href={youtubeLink} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube />
            </SocialLink>
          </SocialLinks>
        </FooterMain>

        <FooterBottom>
          <Copyright>
            {t('footer.copyright', { year: currentYear })}
          </Copyright>
          <LegalLinks>
            <LegalLink to="/privacidade">{t('footer.privacy')}</LegalLink>
            <LegalLink to="/termos">{t('footer.terms')}</LegalLink>
          </LegalLinks>
        </FooterBottom>
      </FooterContent>
      
      {/* REMOVIDO: BackToTop - já existe ScrollToTopButton no App.js */}
    </FooterContainer>
  );
};

export default Footer;